import { render, staticRenderFns } from "./DownArrow.vue?vue&type=template&id=62719f14&scoped=true&"
import script from "./DownArrow.vue?vue&type=script&lang=js&"
export * from "./DownArrow.vue?vue&type=script&lang=js&"
import style0 from "./DownArrow.vue?vue&type=style&index=0&id=62719f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62719f14",
  null
  
)

export default component.exports